// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.62
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-22T13:06:11.488936+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating AdditionalDevice model structure.
 * @see #/components/schemas/AdditionalDevice - reference to schema in open-api-spec.yaml
 * @since 2024-11-22T13:06:11.488936+02:00[Europe/Kiev]
 * @version 1.6.62
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdditionalDevice {
    /**
     * Observation value.
     *
     */
    value: string;
    /**
     * The identifier of the related patient.
     * @dataFormat uuid
     */
    patient_id: string;
    /**
     * The identifier of the related encounter.
     * @dataFormat uuid
     */
    encounter_id: string;
    /**
     * Observation sign code.
     *
     */
    code: string;
    /**
     * The date when observation was created.
     * @dataFormat date-time
     */
    date: string;
    /**
     * The unit of the value.
     *
     */
    unit?: string | null;
    /**
     * Practitioner unique id.
     * @dataFormat uuid
     */
    last_changed_by: string | null;
    /**
     * The identifier of the author - a practitioner.
     * @dataFormat uuid
     */
    author_id?: string | null;
    /**
     * Observation unique id.
     * @dataFormat uuid
     */
    id: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdditionalDevice
 */
export namespace AdditionalDevice {
    /**
     * AdditionalDevice Frontend Model with camelCase properties
     * @since 2024-11-22T13:06:11.488936+02:00[Europe/Kiev]
     * @version 1.6.62
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Observation value.
         * @type string (`dataFormat` is missing)
         */
        value: string;
        /**
         * The identifier of the related patient.
         * @dataFormat uuid
         */
        patientId: string;
        /**
         * The identifier of the related encounter.
         * @dataFormat uuid
         */
        encounterId: string;
        /**
         * Observation sign code.
         * @type string (`dataFormat` is missing)
         */
        code: string;
        /**
         * The date when observation was created.
         * @dataFormat date-time
         */
        @TransformDate() date: Date;
        /**
         * The unit of the value.
         * @type string (`dataFormat` is missing)
         */
        unit?: string | null;
        /**
         * Practitioner unique id.
         * @dataFormat uuid
         */
        lastChangedBy: string | null;
        /**
         * The identifier of the author - a practitioner.
         * @dataFormat uuid
         */
        authorId?: string | null;
        /**
         * Observation unique id.
         * @dataFormat uuid
         */
        id: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdditionalDevice DTO
     * Transforms AdditionalDevice model from/to API object
     * @since 2024-11-22T13:06:11.488936+02:00[Europe/Kiev]
     * @version 1.6.62
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdditionalDevice model */
        static toModel(obj: AdditionalDevice): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdditionalDevice model */
        static toApi(obj: Model): AdditionalDevice {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdditionalDevice;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
